import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type emailTemplates_EmailTemplatesQuery } from "@relay/emailTemplates_EmailTemplatesQuery.graphql";
import { QUERY } from "./email-templates.graphql";
import { EmailTemplatesTable } from "./parts/email-templates-table";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const EmailTemplatesScreen = () => {
	const { t } = useTranslation("common");
	const data = useLazyLoadQuery<emailTemplates_EmailTemplatesQuery>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	const canRead = useHasPermissions(["UserInAccountPermission_Email_Templates"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("emailTemplates.screenTitle")}>
			<EmailTemplatesTable EmailTemplatesFragmentRef={data} />
		</BaseScreen>
	);
};
